module.exports = __webpack_public_path__ + "img/shape-9-gold@2x.5c235412.png";